import ApiService from "./apiservice";

export const PersonelService = {
    getPersonDetail(perno) {
        const params = new URLSearchParams();
        params.append('perno', perno);

        return ApiService.get("GetEosPersonelDetail", params);
    },
    GetAbsentPersonelInCondition(payload) {
        return ApiService.get("Personel/GetAbsentPersonelInCondition", payload);
    },
    GetPersonCalendar(payload) {
        return ApiService.get("personel/GetPersonCalendar", payload);
    },
    GetPersonFullName(payload) {
        return ApiService.get("personel/GetPersonFullName", payload);
    },
    getPageWorkflow(payload) {
        return ApiService.get("personel/GetPageWorkflow", payload);
    },
    GetAccessPersonListWithParam(payload) {
        return ApiService.get("personel/GetAccessPersonListForView", payload);
    },
    GetAccessPersonList(payload) {
        return ApiService.get("personel/GetAccessPersonList", payload);
    },
    IsFreeOfGroupManager(payload) {
        return ApiService.get("Personel/IsFreeOfGroupManager", payload);
    },
    GetPresentPersonel(payload) {
        return ApiService.get("Personel/GetPresentPersonel", payload);
    },
    GetAbsentPersons(payload) {
        return ApiService.get("Personel/GetAbsentPersons", payload);
    },
    GetSectionPersons(payload) {
        return ApiService.get("Personel/GetPersons", payload);
    },
    GetPersonsAttendanceStatus(payload) {
        return ApiService.get("Personel/GetPersonsAttendanceStatus", payload);
    },
    ChangePassword(payload) {
        return ApiService.post("Personel/ChangePassword", null, payload);
    },
    ChangeAdminPassword(payload) {
        return ApiService.post("Personel/ChangeAdminPassword", null, payload);
    },
    UpdateDomainUserName(params) {
        return ApiService.post("personel/UpdateDomainUserName", null, params);
    },
    FindUserDomainName(payload) {
        return ApiService.get("personel/FindUserDomainName", payload);
    },
    getPersonelsSection(payload) {
        return ApiService.get("personel/getPersonelsSection", payload);
    },
    EosPerson(params) {
        return ApiService.get("personel/EosPerson", params);
    },
    ChangeSetting(params) {
        return ApiService.post("personel/ChangeSetting", null, params);
    },
    UseActiveDirectory(params) {
        return ApiService.get("personel/UseActiveDirectory", params);
    },
    GetPernoOfUsername(params) {
        return ApiService.get("GetPernoOfUsername", params);
    },
};